import i11 from "../assets/projects/p10.jpeg";
import i12 from "../assets/projects/p11.jpeg";

import i21 from "../assets/projects/p12.jpeg";
import i22 from "../assets/projects/p13.jpeg";

import i31 from "../assets/projects/p14.jpeg";
import i32 from "../assets/projects/p15.jpeg";

import i41 from "../assets/projects/p16.jpg";
import i42 from "../assets/projects/p17.jpg";

import i51 from "../assets/projects/unicef-beirut.jpg";
import i52 from "../assets/projects/unicef-beirut1.jpg";

export const projects = [
  { 
    title: "", 
    country: "📍 Iraq", 
    images: [
      i11,
      i12
    ]
  },
  { 
    title: "", 
    country: "📍 Lebanon", 
    images: [
      i21,
      i22
    ]
  },
  { 
    title: "", 
    country: "📍 Iraq", 
    images: [
      i31,
      i32
    ]
  },
  { 
    title: "", 
    country: "📍 Lebanon", 
    images: [
      i41,
      i42
    ]
  },
  { 
    title: "UNICEF BML water establishment", 
    country: "📍 Beirut, Badaro", 
    images: [
      i51,
      i52
    ]
  }
];